export default {"src":"/_next/static/media/mockup-app.39d1573e.svg","height":383,"width":640,"blurWidth":0,"blurHeight":0};